// Unifie le lecteur natif (`BarcodeDetector`) et le repli ZXing derrière une seule interface : le
// reste de l'app (main.ts) n'a pas à savoir lequel des deux est actif. Le choix se fait une fois, à
// la création (`createBarcodeScanner`), pas à chaque image — `getSupportedFormats()` a un coût et le
// résultat ne change pas en cours de session.
//
// Import dynamique de `zxingDetector.js` (et donc du ~1 Mo de WASM qu'il référence) : budget JS
// mobile oblige (CLAUDE.md/README), les navigateurs avec `BarcodeDetector` natif — Chrome/Android,
// la majorité du trafic Android — ne doivent jamais le télécharger.
import { createNativeDetector } from './nativeDetector.js';
import { selectEan } from './selectEan.js';

export interface BarcodeScanner {
  readonly engine: 'native' | 'zxing-wasm';
  /** `null` si aucun code EAN/UPC exploitable n'a été détecté dans cette image. */
  detect(frame: ImageData): Promise<string | null>;
}

export async function createBarcodeScanner(): Promise<BarcodeScanner> {
  const native = await createNativeDetector();
  if (native) {
    return {
      engine: 'native',
      async detect(frame) {
        const results = await native(frame);
        return selectEan(results);
      },
    };
  }
  const { detectWithZXing } = await import('./zxingDetector.js');
  return {
    engine: 'zxing-wasm',
    async detect(frame) {
      const results = await detectWithZXing(frame);
      return selectEan(results);
    },
  };
}
